export const WiseConfig = ()=>({
        BaseUrl: window.WiseBaseUrl || 'https://probiblio.hostedwise.nl',
        LibraryId: window.WiseLibraryId || '6190'
    });
